import React, { useRef, useEffect, useState } from 'react';
import Protected from './Protected';
export default function BinauralGenerator() {

    const audioContextRef = useRef(null);
    const audioBufferRef = useRef(null);
    const audioRef = useRef(null);
    const gainNodeRef = useRef(null);
    const [carrierFrequency, setCarrierFrequency] = useState(440);
    const [beatFrequency, setBeatFrequency] = useState(5);
    const [isPlaying, setIsPlaying] = useState(false);
    const [volume, setVolume] = useState(50); // Default volume (50%)

    useEffect(() => {
        //audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        //audioContextRef.current.loop = true;
        loadAudio();
    }, []);

    const loadAudio = async () => {
        const response = await fetch('/api/music/binaural', {
            method: "POST",
            body: JSON.stringify({
                CarrierFrequency: Number(carrierFrequency),
                BeatFrequency: Number(beatFrequency)
            })
        });

        if (!audioContextRef.current) {
            audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        }

        const arrayBuffer = await response.arrayBuffer();
        audioBufferRef.current = await audioContextRef.current.decodeAudioData(arrayBuffer);
        gainNodeRef.current = audioContextRef.current.createGain();
        
    };

    const startAudio = () => {
        if (audioBufferRef.current && audioContextRef.current) {
            audioRef.current = audioContextRef.current.createBufferSource();
            audioRef.current.buffer = audioBufferRef.current;
            audioRef.current.connect(gainNodeRef.current).connect(audioContextRef.current.destination);

            gainNodeRef.current.gain.setValueAtTime(0, audioContextRef.current.currentTime);
            audioRef.current.loop = true;

            const fadeInDuration = 5; // Duration in seconds
            gainNodeRef.current.gain.linearRampToValueAtTime(volume / 100, audioContextRef.current.currentTime + fadeInDuration);

            audioRef.current.start();
            setIsPlaying(true);
        } else {
            console.error("Audio buffer or context not initialized.");
        }
    };

    const stopAudio = () => {
        if (audioRef.current) {

            //const fadeOutDuration = 2; // Duration in seconds
            //gainNodeRef.current.gain.linearRampToValueAtTime(0, audioContextRef.current.currentTime + fadeOutDuration);
            //await new Promise(resolve => setTimeout(resolve, fadeOutDuration * 1000));
            gainNodeRef.current.gain.setValueAtTime(0, audioContextRef.current.currentTime);
            audioRef.current.stop();
            audioRef.current.disconnect();
            audioRef.current = null;
            setIsPlaying(false);
        }
    };

    const handlePlayPause = async () => {
        if (!audioRef.current) {
            await loadAudio();
        }
        isPlaying ? stopAudio() : startAudio();
    };

    const handleVolumeChange = (e) => {
        const newVolume = e.target.value;
        setVolume(newVolume);
        gainNodeRef.current.gain.setValueAtTime(newVolume / 100, audioContextRef.current.currentTime); // Volume range is 0.0 to 1.0
    };

    const handleSetCarrierFrequency = (e) => {
        //stopAudio();
        setCarrierFrequency(e.target.value)
        //loadAudio();
    };

    const handleSetBeatFrequency = (e) => {
        //stopAudio();
        setBeatFrequency(e.target.value)
        //loadAudio();
    };

    return (
        <Protected>
            <div className="dashed-border">
                <h1 className="font-thin">Binaural Generator</h1>
            </div>
            <div className="row mt-3">
                <div className="col-md-3 col-12">
                    <label className="form-label">Carrier Frequency {carrierFrequency} Hz</label>
                    <input type="range" value={carrierFrequency} className="form-range" min="100" max="1000" step="10" onChange={handleSetCarrierFrequency} />
                </div>
                <div className="col-md-3 col-12">
                    <label class="form-label">Beat Frequency {beatFrequency} Hz</label>
                    <input type="range" value={beatFrequency} className="form-range" min="1" max="30" step="1" onChange={handleSetBeatFrequency} />
                </div>
                <div className="col-md-3 col-12">
                    <label className="form-label">Volume: {volume}%</label>
                    <input className="form-range" type="range" min="0" max="100" value={volume} onChange={handleVolumeChange} />
                </div>
                {/*<button onClick={loadAudio} className="btn btn-primary">Load Binaural Audio</button>*/}
                <div className="col-md-12 col-12">
                    <button onClick={handlePlayPause} className="btn btn-secondary"><span className={isPlaying ? 'icon-pause' : 'icon-play'}></span></button>

                    <button onClick={stopAudio} className="btn btn-primary"><span className="icon-stop"></span></button>
                </div>
                </div>
        </Protected>
    );
};